export class ConstantVars {
  public static ToastErrorTimeout: number = 5000;
  public static ToastSucessTimeout: number = 300;
  public static Test: any[] = [
    {
      Student_Status_Type_Name: 'Active',
      Gender_Type_Name: 'Male',
      Education_Type_Name: "Bachelor's Degree",
      Profile_Icon_File_Object_Id: '12345-abcde',
      Course_Category_Type_Code: 'CS',
      Course_Category_Type_Name: 'Computer Science',
      Career_Stream_Type_Code: 'ENG',
      Login_Readiness_Type_Code: 'READY',
      Student_Status_Reason_Type_Code: 'ENROLLED',
      Student_Status_Reason_Type_Name: 'Enrolled in Course',
      Student_Status_Comment_Text: 'Student is actively participating.',
      Address_Line_1: '123 Main Street',
      Address_Line_2: 'Apt 4B',
      Address_Line_3: '',
      City_Name: 'New York',
      State_Code: 'NY',
      State_Name: 'New York',
      Country_Code: 'US',
      Country_Name: 'United States',
      Postal_Code: '10001',
      Student_Id: 101,
      Nick_Name: 'Johnny',
      First_Name: 'John',
      Middle_Name: 'A.',
      Last_Name: 'Doe',
      Email_Address: 'john.doe@example.com',
      Gender_Type_Code: 'M',
      Primary_Phone_Country_Code: '+1',
      Primary_Phone_Number: '1234567890',
      Secondary_Phone_Country_Code: '+1',
      Secondary_Phone_Number: '9876543210',
      Education_Type_Code: 'BACHELORS',
      Password_Text: 'hashedPassword123',
      Temporary_Passcode: null,
      Address_Id: 'addr-123',
      Prospect_Student_Ind: 'N',
      Date_Of_Birth: '1995-05-15',
      Profile_Picture_File_Object_ID: 'profile-12345',
      Student_Status_Type_Code: 'ACTIVE',
      Number_Of_Failed_Login: 0,
      Login_Status_Type_Code: 'LOGGED_IN',
      Passcode_Reset_Time: null,
      Passcode_Sent_To: null,
      Password_Last_Reset_Time: '2023-10-01T12:00:00Z',
      Password_Link_Reset_Time: null,
      Creation_Date: '2023-01-01T10:00:00Z',
      Created_By: 'admin',
      Updation_Date: '2023-10-05T14:30:00Z',
      Updated_By: 'admin',
      CourseName: 'Computer Science 101',
      CourseAndYear: 'CS101 - 2023',
      ExamYear: 2023,
      Username: 'john.doe',
    },
    {
      Student_Status_Type_Name: 'Active',
      Gender_Type_Name: 'Male',
      Education_Type_Name: "Bachelor's Degree",
      Profile_Icon_File_Object_Id: '12345-abcde',
      Course_Category_Type_Code: 'CS',
      Course_Category_Type_Name: 'Computer Science',
      Career_Stream_Type_Code: 'ENG',
      Login_Readiness_Type_Code: 'READY',
      Student_Status_Reason_Type_Code: 'ENROLLED',
      Student_Status_Reason_Type_Name: 'Enrolled in Course',
      Student_Status_Comment_Text: 'Student is actively participating.',
      Address_Line_1: '123 Main Street',
      Address_Line_2: 'Apt 4B',
      Address_Line_3: '',
      City_Name: 'New York',
      State_Code: 'NY',
      State_Name: 'New York',
      Country_Code: 'US',
      Country_Name: 'United States',
      Postal_Code: '10001',
      Student_Id: 101,
      Nick_Name: 'Johnny',
      First_Name: 'John',
      Middle_Name: 'A.',
      Last_Name: 'Doe',
      Email_Address: 'john.doe@example.com',
      Gender_Type_Code: 'M',
      Primary_Phone_Country_Code: '+1',
      Primary_Phone_Number: '1234567890',
      Secondary_Phone_Country_Code: '+1',
      Secondary_Phone_Number: '9876543210',
      Education_Type_Code: 'BACHELORS',
      Password_Text: 'hashedPassword123',
      Temporary_Passcode: null,
      Address_Id: 'addr-123',
      Prospect_Student_Ind: 'N',
      Date_Of_Birth: '1995-05-15',
      Profile_Picture_File_Object_ID: 'profile-12345',
      Student_Status_Type_Code: 'ACTIVE',
      Number_Of_Failed_Login: 0,
      Login_Status_Type_Code: 'LOGGED_IN',
      Passcode_Reset_Time: null,
      Passcode_Sent_To: null,
      Password_Last_Reset_Time: '2023-10-01T12:00:00Z',
      Password_Link_Reset_Time: null,
      Creation_Date: '2023-01-01T10:00:00Z',
      Created_By: 'admin',
      Updation_Date: '2023-10-05T14:30:00Z',
      Updated_By: 'admin',
      CourseName: 'Computer Science 101',
      CourseAndYear: 'CS101 - 2023',
      ExamYear: 2023,
      Username: 'john.doe',
    },
    {
      Student_Status_Type_Name: 'Active',
      Gender_Type_Name: 'Male',
      Education_Type_Name: "Bachelor's Degree",
      Profile_Icon_File_Object_Id: '12345-abcde',
      Course_Category_Type_Code: 'CS',
      Course_Category_Type_Name: 'Computer Science',
      Career_Stream_Type_Code: 'ENG',
      Login_Readiness_Type_Code: 'READY',
      Student_Status_Reason_Type_Code: 'ENROLLED',
      Student_Status_Reason_Type_Name: 'Enrolled in Course',
      Student_Status_Comment_Text: 'Student is actively participating.',
      Address_Line_1: '123 Main Street',
      Address_Line_2: 'Apt 4B',
      Address_Line_3: '',
      City_Name: 'New York',
      State_Code: 'NY',
      State_Name: 'New York',
      Country_Code: 'US',
      Country_Name: 'United States',
      Postal_Code: '10001',
      Student_Id: 101,
      Nick_Name: 'Johnny',
      First_Name: 'John',
      Middle_Name: 'A.',
      Last_Name: 'Doe',
      Email_Address: 'john.doe@example.com',
      Gender_Type_Code: 'M',
      Primary_Phone_Country_Code: '+1',
      Primary_Phone_Number: '1234567890',
      Secondary_Phone_Country_Code: '+1',
      Secondary_Phone_Number: '9876543210',
      Education_Type_Code: 'BACHELORS',
      Password_Text: 'hashedPassword123',
      Temporary_Passcode: null,
      Address_Id: 'addr-123',
      Prospect_Student_Ind: 'N',
      Date_Of_Birth: '1995-05-15',
      Profile_Picture_File_Object_ID: 'profile-12345',
      Student_Status_Type_Code: 'ACTIVE',
      Number_Of_Failed_Login: 0,
      Login_Status_Type_Code: 'LOGGED_IN',
      Passcode_Reset_Time: null,
      Passcode_Sent_To: null,
      Password_Last_Reset_Time: '2023-10-01T12:00:00Z',
      Password_Link_Reset_Time: null,
      Creation_Date: '2023-01-01T10:00:00Z',
      Created_By: 'admin',
      Updation_Date: '2023-10-05T14:30:00Z',
      Updated_By: 'admin',
      CourseName: 'Computer Science 101',
      CourseAndYear: 'CS101 - 2023',  
      ExamYear: 2023,
      Username: 'john.doe',
    },
  ];
}
